// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#transparent, #salary {
    background-color: white !important;
    min-width: 120% !important;
  }
  
  .showOnMobile {
    display: none
  }
  
  
  .basic-info {
    margin-top: 40px !important;
    margin-bottom: 0;
  }
  
  .availability-overlay {
    width: 100%;
    height: 100%;            
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    background: #666666 0% 0% no-repeat padding-box;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    align-items: center;
    opacity: 0.5;
    cursor: none;
    z-index: 9;
  }
  
  .availability-container {
    position: relative;
  }
  
  .hide-overlay {
    display: none;
  }
  
  .profile-input, .profile-input > .ant-input {
    height: 40px !important;
    text-align: left !important;
  
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0;
    color: #212121 !important;
    opacity: 1;
  }
  
  .duration-input {
    display: flex;
    align-items: center;
  }
   .duration-input .ant-input-number {
    width: 40px; 
    height: 32px
   }
  .duration-input .ant-input-number-handler-wrap {
    display: none !important
  }
  
  .profile-input > .ant-select {
    width: 100% !important;
    text-align: left;
    font-size: 16px !important;
    color: #444444 !important;
  }
  
  
  /* .profile-row {
    margin-bottom: 24px !important;
  } */
  .verticallyAligned {
    flex-direction: row-reverse !important
  }
  
  .profile-input > .ant-select-selection, .profile-input > div > .ant-select-selection, .profile-input > .ant-select-selection--single {
    text-align: left;
    font-size: 16px !important;
    color: #444444 !important;
  }
  
  .select-option {
    text-align: left;
    font-size: 16px !important;
    color: #444444 !important;
  }
  
  .input-error {
    border: 1px solid #F86567 !important
  }
  
  .salary-input-field span.input-error {
    border: none !important;
  }
  
  .input-error .ant-input {
    border: 1px solid #F86567 !important
  }
  /* Pretest CSS starts here */
  
  .pretest-page-two-header {
    text-align: left;
    font-size: 28px;
    line-height: 37px;
    font-weight: 500;
    letter-spacing: 0;
    color: #212121;
    opacity: 1;
  }
  
  .pretest-page-two-header-description {
    margin-top: 40px;
    text-align: left;
  
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: #888888;
    opacity: 1;
  }
  
  .pretest-section-error {
    text-align: left;
  
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0;
    color: #F86567 !important;
    opacity: 1;
  }
  
  .pretest-section-title {
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0;
    color: #444444;
    opacity: 1;
  }
  .pretest-section-title-error {
    color: #F86567 !important;
  }
  .pretest-section-title-margin {
    margin-left: 10px;
  }
  
  .pretest-basic-info-section-spacing {
    margin-top: 58px
  }
  
  .pretest-english-proficiency .ant-radio-group {
    width: 98%;
  }
  
  .pretest-english-proficiency.availability-section .ant-radio-group {
    flex-direction: column;
    gap: 10px;
  }
  
  .pretest-english-proficiency.availability-section .ant-radio-group .ant-card{
    width: 98%;
  }
  
  .pretest-english-proficiency .ant-radio-wrapper, .pretest-availability-option .ant-radio-wrapper {
    white-space: normal;
  }
  
  .pretest-english-proficiency .ant-radio-inner::after, .pretest-availability-option .ant-radio-inner::after {
    background: #444444 0 0 no-repeat padding-box !important;
  }
  
  .pretest-availability-option .ant-radio-inner {
    border-color: #444444 !important
  }
  .pretest-english-proficiency .ant-radio-inner {
    top: 35% !important;
    border-color: #444444 !important
  }
  
  .pretest-eng-pro-title {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    line-height: 32px;
    letter-spacing: 0;
    color: #444444;
    opacity: 1;
  }
  
  .pretest-eng-pro-detail {
    text-align: left;
  
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0;
    color: #888888;
    opacity: 1;
  }
  
  .pretest-availability-option .ant-tag-checkable {
      background: #4444440F 0% 0% no-repeat padding-box;
      color: #444444;
      padding-top: 7px;
      padding-bottom: 6px;
      border-color: transparent;
      padding-left: 12px;
      border-radius: 50px;
      padding-right: 12px;
  }
  
  .pretest-availability-option .ant-tag-checkable:not(.ant-tag-checkable-checked):hover,
  .pretest-availability-option-clicked {
    background: #666666 0% 0% no-repeat padding-box;
    color: #FFFFFF;
  }
  
  .profile-input .ant-input-suffix {
    text-align: right;
  
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0;
    color: #CCCCCC !important;
    opacity: 1;
  }
  .pretest-basic-info-warning-card .ant-card-body {
    padding: 0 !important;
  }
  
  .pretest-basic-info-warning-card {
    margin-top: 24px;
    border-left-color: #F86567;
    border-left-width: 4px;
    padding-top: 15px !important;
    padding-bottom: 14px !important;
    padding-left: 16px !important
  }
  
  .pretest-basic-info-error-nor {
    text-align: left;
    letter-spacing: 0;
    color: #444444;
    opacity: 1;
    font-size: 14px;
    line-height: 24px;
  }
  
  .availability-section-title {
    margin-bottom: 48px;
    text-align: left;
    font-size: 20px !important;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0;
    color: #444444;
    opacity: 1;
  }
  
  .pretest-basic-info-error-bold {
    font-weight: 500;
  }
  
  .pretest-page-two-header-description-ai {
    margin-top: 20px;
    color: #212121;
  }
  
  .pretest-page-two-header-description-info {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #005499;
    border: 1px solid #B3DDFF;
    border-radius: 16px;
    background: linear-gradient(0deg, #B3DDFF, #B3DDFF), linear-gradient(0deg, #E5F4FF, #E5F4FF);
    padding: 16px;
    font-size: 16px;
    gap: 10px;
    margin-top: 20px;
    margin-bottom: 50px;
  }
  
  .pretest-option-card-icon {
    margin-right: 14px;
  }
  /* Pretest CSS ends here */
  
  @media (max-width: 1024px) {
    .mobileHidden {
        display: none !important;
    }
    .pretest-english-proficiency .ant-radio-group {
      width: 100%;
    }
    .showOnMobile {
      display: inline-block;
      color: red;
      line-height: 16px;
      margin-bottom: 16px;
    }
    .mobileMargin {
      line-height: 16px;
      margin-bottom: 16px;
    }
   }
  
  @media (min-width: 1024px) {
    .Profile-Box{
        padding: 50px 100px 10px !important;
        margin-bottom: 0 !important;
    }
  }
  
  .verticallyAligned {
    display: flex;
    align-items: flex-start;
  }
  
  .sub-SectionTitle {
    color: #888888;
    font-size: 12px;
  }
  
  .github-section-title {
    display: flex;
  }
  
  .github-section-description {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
  
  }
  
  .github-section-error {
    color: #F86567;
    font-size: 12px;
  }
  
  .github-section-input > div {
    float: initial;
    margin-bottom: 30px !important;
    width: 98%;
  }
  
  .github-section-input.pretest-section-title-error .input-name {
    color: #F86567;
  }
  
  .availability-question .ant-card-body {
    padding: 16px !important
  }
  .start-time-input {
    width: 40px !important;
    height: initial !important;
    padding: 2px 8px !important;
    font-size: 14px !important;
  }
  
  .start-time-input::-webkit-outer-spin-button,
  .start-time-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    width: 0;
    margin: 0;
  }
  
  /* Firefox */
  .start-time-input[type=number] {
    -moz-appearance: textfield;
  }
  
  .other-role-type {
    display: flex;
    margin-top: 4px;
  }
  
  .other-role-type span {
    margin-right: 10px;
  }
  
  .important {
    color: #F86567
  }`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/AvailabilityCard/availabilityDuration.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE;EACF;;;EAGA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,+CAA+C;IAC/C,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;;IAE3B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;GACC;IACC,WAAW;IACX;GACD;EACD;IACE;EACF;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;EAC3B;;;EAGA;;KAEG;EACH;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;EACF;EACA,4BAA4B;;EAE5B;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE;EACF;EACA;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;MACI,iDAAiD;MACjD,cAAc;MACd,gBAAgB;MAChB,mBAAmB;MACnB,yBAAyB;MACzB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;;IAEE,+CAA+C;IAC/C,cAAc;EAChB;;EAEA;IACE,iBAAiB;;IAEjB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;IAC/B;EACF;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,4FAA4F;IAC5F,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;EACA,0BAA0B;;EAE1B;IACE;QACI,wBAAwB;IAC5B;IACA;MACE,WAAW;IACb;IACA;MACE,qBAAqB;MACrB,UAAU;MACV,iBAAiB;MACjB,mBAAmB;IACrB;IACA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;GACD;;EAED;IACE;QACI,mCAAmC;QACnC,2BAA2B;IAC/B;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;EAErB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;EACF;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;IACxB,QAAQ;IACR,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;EACF","sourcesContent":["#transparent, #salary {\n    background-color: white !important;\n    min-width: 120% !important;\n  }\n  \n  .showOnMobile {\n    display: none\n  }\n  \n  \n  .basic-info {\n    margin-top: 40px !important;\n    margin-bottom: 0;\n  }\n  \n  .availability-overlay {\n    width: 100%;\n    height: 100%;            \n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    background: #666666 0% 0% no-repeat padding-box;\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 16px;\n    align-items: center;\n    opacity: 0.5;\n    cursor: none;\n    z-index: 9;\n  }\n  \n  .availability-container {\n    position: relative;\n  }\n  \n  .hide-overlay {\n    display: none;\n  }\n  \n  .profile-input, .profile-input > .ant-input {\n    height: 40px !important;\n    text-align: left !important;\n  \n    font-size: 16px;\n    line-height: 21px;\n    letter-spacing: 0;\n    color: #212121 !important;\n    opacity: 1;\n  }\n  \n  .duration-input {\n    display: flex;\n    align-items: center;\n  }\n   .duration-input .ant-input-number {\n    width: 40px; \n    height: 32px\n   }\n  .duration-input .ant-input-number-handler-wrap {\n    display: none !important\n  }\n  \n  .profile-input > .ant-select {\n    width: 100% !important;\n    text-align: left;\n    font-size: 16px !important;\n    color: #444444 !important;\n  }\n  \n  \n  /* .profile-row {\n    margin-bottom: 24px !important;\n  } */\n  .verticallyAligned {\n    flex-direction: row-reverse !important\n  }\n  \n  .profile-input > .ant-select-selection, .profile-input > div > .ant-select-selection, .profile-input > .ant-select-selection--single {\n    text-align: left;\n    font-size: 16px !important;\n    color: #444444 !important;\n  }\n  \n  .select-option {\n    text-align: left;\n    font-size: 16px !important;\n    color: #444444 !important;\n  }\n  \n  .input-error {\n    border: 1px solid #F86567 !important\n  }\n  \n  .salary-input-field span.input-error {\n    border: none !important;\n  }\n  \n  .input-error .ant-input {\n    border: 1px solid #F86567 !important\n  }\n  /* Pretest CSS starts here */\n  \n  .pretest-page-two-header {\n    text-align: left;\n    font-size: 28px;\n    line-height: 37px;\n    font-weight: 500;\n    letter-spacing: 0;\n    color: #212121;\n    opacity: 1;\n  }\n  \n  .pretest-page-two-header-description {\n    margin-top: 40px;\n    text-align: left;\n  \n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0;\n    color: #888888;\n    opacity: 1;\n  }\n  \n  .pretest-section-error {\n    text-align: left;\n  \n    font-size: 14px;\n    line-height: 19px;\n    letter-spacing: 0;\n    color: #F86567 !important;\n    opacity: 1;\n  }\n  \n  .pretest-section-title {\n    text-align: left;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 32px;\n    letter-spacing: 0;\n    color: #444444;\n    opacity: 1;\n  }\n  .pretest-section-title-error {\n    color: #F86567 !important;\n  }\n  .pretest-section-title-margin {\n    margin-left: 10px;\n  }\n  \n  .pretest-basic-info-section-spacing {\n    margin-top: 58px\n  }\n  \n  .pretest-english-proficiency .ant-radio-group {\n    width: 98%;\n  }\n  \n  .pretest-english-proficiency.availability-section .ant-radio-group {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .pretest-english-proficiency.availability-section .ant-radio-group .ant-card{\n    width: 98%;\n  }\n  \n  .pretest-english-proficiency .ant-radio-wrapper, .pretest-availability-option .ant-radio-wrapper {\n    white-space: normal;\n  }\n  \n  .pretest-english-proficiency .ant-radio-inner::after, .pretest-availability-option .ant-radio-inner::after {\n    background: #444444 0 0 no-repeat padding-box !important;\n  }\n  \n  .pretest-availability-option .ant-radio-inner {\n    border-color: #444444 !important\n  }\n  .pretest-english-proficiency .ant-radio-inner {\n    top: 35% !important;\n    border-color: #444444 !important\n  }\n  \n  .pretest-eng-pro-title {\n    text-align: left;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 32px;\n    letter-spacing: 0;\n    color: #444444;\n    opacity: 1;\n  }\n  \n  .pretest-eng-pro-detail {\n    text-align: left;\n  \n    font-size: 12px;\n    line-height: 18px;\n    letter-spacing: 0;\n    color: #888888;\n    opacity: 1;\n  }\n  \n  .pretest-availability-option .ant-tag-checkable {\n      background: #4444440F 0% 0% no-repeat padding-box;\n      color: #444444;\n      padding-top: 7px;\n      padding-bottom: 6px;\n      border-color: transparent;\n      padding-left: 12px;\n      border-radius: 50px;\n      padding-right: 12px;\n  }\n  \n  .pretest-availability-option .ant-tag-checkable:not(.ant-tag-checkable-checked):hover,\n  .pretest-availability-option-clicked {\n    background: #666666 0% 0% no-repeat padding-box;\n    color: #FFFFFF;\n  }\n  \n  .profile-input .ant-input-suffix {\n    text-align: right;\n  \n    font-size: 16px;\n    line-height: 21px;\n    letter-spacing: 0;\n    color: #CCCCCC !important;\n    opacity: 1;\n  }\n  .pretest-basic-info-warning-card .ant-card-body {\n    padding: 0 !important;\n  }\n  \n  .pretest-basic-info-warning-card {\n    margin-top: 24px;\n    border-left-color: #F86567;\n    border-left-width: 4px;\n    padding-top: 15px !important;\n    padding-bottom: 14px !important;\n    padding-left: 16px !important\n  }\n  \n  .pretest-basic-info-error-nor {\n    text-align: left;\n    letter-spacing: 0;\n    color: #444444;\n    opacity: 1;\n    font-size: 14px;\n    line-height: 24px;\n  }\n  \n  .availability-section-title {\n    margin-bottom: 48px;\n    text-align: left;\n    font-size: 20px !important;\n    font-weight: 500;\n    line-height: 32px;\n    letter-spacing: 0;\n    color: #444444;\n    opacity: 1;\n  }\n  \n  .pretest-basic-info-error-bold {\n    font-weight: 500;\n  }\n  \n  .pretest-page-two-header-description-ai {\n    margin-top: 20px;\n    color: #212121;\n  }\n  \n  .pretest-page-two-header-description-info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #005499;\n    border: 1px solid #B3DDFF;\n    border-radius: 16px;\n    background: linear-gradient(0deg, #B3DDFF, #B3DDFF), linear-gradient(0deg, #E5F4FF, #E5F4FF);\n    padding: 16px;\n    font-size: 16px;\n    gap: 10px;\n    margin-top: 20px;\n    margin-bottom: 50px;\n  }\n  \n  .pretest-option-card-icon {\n    margin-right: 14px;\n  }\n  /* Pretest CSS ends here */\n  \n  @media (max-width: 1024px) {\n    .mobileHidden {\n        display: none !important;\n    }\n    .pretest-english-proficiency .ant-radio-group {\n      width: 100%;\n    }\n    .showOnMobile {\n      display: inline-block;\n      color: red;\n      line-height: 16px;\n      margin-bottom: 16px;\n    }\n    .mobileMargin {\n      line-height: 16px;\n      margin-bottom: 16px;\n    }\n   }\n  \n  @media (min-width: 1024px) {\n    .Profile-Box{\n        padding: 50px 100px 10px !important;\n        margin-bottom: 0 !important;\n    }\n  }\n  \n  .verticallyAligned {\n    display: flex;\n    align-items: flex-start;\n  }\n  \n  .sub-SectionTitle {\n    color: #888888;\n    font-size: 12px;\n  }\n  \n  .github-section-title {\n    display: flex;\n  }\n  \n  .github-section-description {\n    font-size: 14px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n  \n  }\n  \n  .github-section-error {\n    color: #F86567;\n    font-size: 12px;\n  }\n  \n  .github-section-input > div {\n    float: initial;\n    margin-bottom: 30px !important;\n    width: 98%;\n  }\n  \n  .github-section-input.pretest-section-title-error .input-name {\n    color: #F86567;\n  }\n  \n  .availability-question .ant-card-body {\n    padding: 16px !important\n  }\n  .start-time-input {\n    width: 40px !important;\n    height: initial !important;\n    padding: 2px 8px !important;\n    font-size: 14px !important;\n  }\n  \n  .start-time-input::-webkit-outer-spin-button,\n  .start-time-input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    width: 0;\n    margin: 0;\n  }\n  \n  /* Firefox */\n  .start-time-input[type=number] {\n    -moz-appearance: textfield;\n  }\n  \n  .other-role-type {\n    display: flex;\n    margin-top: 4px;\n  }\n  \n  .other-role-type span {\n    margin-right: 10px;\n  }\n  \n  .important {\n    color: #F86567\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
